/**
 * @file File reader component
 * @author Heino Lenting
 */
import { FileReaderService } from '../file-reader.service';
var FileReaderComponent = /** @class */ (function () {
    function FileReaderComponent(fileReaderService) {
        this.fileReaderService = fileReaderService;
        this.fileReaderService.registerComponent(this);
    }
    FileReaderComponent.prototype.openFileWindow = function (allowedExtensions) {
        var _this = this;
        // Dit werkt in Chrome en Firefox. Nog testen/aanpassen voor Edge.
        // The change event of the file-input, triggers the fileSelected handler, only if a file was selected by the user.
        // But if the user cancels the file selection dialog, we have no good way to handle that. Therefore we attach to
        // document.body.onFocus for one single event. If the body gets focus again, the dialog form must have lost it (and
        // must be closed). We can now cancel the file import action. Otherwise we keep getting the
        // APP.LISTS.WAIT_UNTIL_ACTION_IS_FINISHED error after a user cancel, until the browser is refreshed (F5).
        if (document.activeElement) {
            document.activeElement.addEventListener('focus', function () {
                window.setTimeout(function () {
                    // We have to wait some seconds here to be sure that the fileSelected event has fired and userSelectedAFile
                    // is set (only if the user selected a file). Because this focus event fires before the change event.
                    if (!_this.userSelectedAFile) {
                        _this.fileReaderService.cancelFile();
                    }
                }, 3000);
            }, { once: true, capture: true });
        }
        this.userSelectedAFile = false;
        this.file.nativeElement.accept = allowedExtensions;
        this.file.nativeElement.click();
    };
    FileReaderComponent.prototype.fileSelected = function () {
        this.userSelectedAFile = true;
        this.fileReaderService.readFile(this.file.nativeElement.files[0]);
        // See: https://stackoverflow.com/questions/7179627/files-input-change-event-fires-only-once
        this.file.nativeElement.value = '';
    };
    return FileReaderComponent;
}());
export { FileReaderComponent };
